import React from 'react'
import { Link } from 'react-router-dom'; 
import "./styles.scss";

export default function Breadcrumb ({ path }) {
  return (
    <div className="breadcrumb-wrapper pb-1">
    {path.map((segment, index) => {
      const isActive = index === path.length - 1; // Last item is active
      return (
        <span key={index} className={isActive ? 'active text-capitalize' : ' text-capitalize'}>
          {segment.path && !isActive ? (
            <Link to={segment.path}>{segment.text}</Link>
          ) : (
            <span>{segment.text}</span>
          )}
          {index < path.length - 1 && <span> / </span>} {/* Separator */}
        </span>
      );
    })}
  </div>
  )
}
